<template>
  <div>
    <page-header>
      <template v-slot:title>
        <div>
          Olá, <span style="font-weight: bold;">{{user.name}}!</span> Acompanhe seu resumo. 😎
        </div>
      </template>
    </page-header>

    <v-row>
      <v-col>
        <home-financial-info></home-financial-info>
        <next-events></next-events>
        <overdue-movements class="mt-5" is_component_used_in_home_page></overdue-movements>
      </v-col>
      <v-col>
        <next-events v-if="which_list == 'next-events'" is_component_used_in_all_events @changeCalendar="changeCalendar()" class="mt-n5"></next-events>
        <events-calendar v-if="which_list == 'events-calendar'" is_component_used_in_all_events :use_with_menu="true" @changeCalendar="changeCalendar()"></events-calendar>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import EventsCalendar from './events_agenda/calendar/EventsCalendar.vue'
import NextEvents from './events_agenda/next_events/NextEvents.vue'
import Invoicing from './financial/invoicing/Invoicing.vue'
import PageHeader from './shared/PageHeader.vue'
import OverdueMovements from './financial/movements/OverdueMovements.vue'
import HomeFinancialInfo from './financial/counters/HomeFinancialInfo.vue'
import Api from '@/api'

export default {
  name: 'HomeScreen',
  components: {
    PageHeader,
    EventsCalendar,
    Invoicing,
    NextEvents,
    OverdueMovements,
    HomeFinancialInfo
  },
  data() {
    return {
      which_list: '',
    }
  },
  methods: {
    changeCalendar(){
      if(this.which_list == 'events-calendar'){
        this.which_list = 'next-events'
        localStorage.which_list = this.which_list;
      }else{
        this.which_list = 'events-calendar'
        localStorage.which_list = this.which_list;
      }
    },
    getData(){
      localStorage.which_list ? this.which_list = localStorage.which_list : this.which_list = 'events-calendar'
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      activeCompanyId: state => state.App.activeCompanyId,
      user: state => state.User.user
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getData()
  },
  watch: {
    activeCompanyId(){
      this.getData()
    }
  },
}
</script>

<style lang="scss">
</style>